module.exports = __webpack_public_path__ + "img/南五味子.72843f26.jpg";